import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { HttpResponse, JobsResponse } from "@/types";

export function useGetJobs(options?: Partial<UseQueryOptions<JobsResponse[]>>) {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    ...options,
    queryKey: ["jobs", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs`;
      const res = await httpClient.get<
        JobsResponse[],
        HttpResponse<JobsResponse[]>
      >(path);
      return res.data;
    },
  });
}
